import React from 'react'
// import { Link } from 'react-router-dom';
import "./Favicon.css"

export default function Navbar(props) {
    return (

        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <a className="navbar-brand" href="#"><img className="favicon" src="favicon.png" alt="" /></a>
            {/* <link className="navbar-brand" to="#"><img className="favicon" src="favicon.png" alt="" /></link> */}
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item ">
                        {/* <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link> */}
                        <a className="nav-link" href="#">Home <span className="sr-only">(current)</span></a>
                    </li>
                    {/* <li className="nav-item">
                        <Link className="nav-link" to="/about">{props.about}</Link>
                    </li> */}
                </ul>

                <div className={`form-check form-switch text-${props.mode === 'light' ? '#042743' : 'light'}`}>
                    <input className="form-check-input" onClick={props.toggleMode} type="checkbox" id="flexSwitchCheckDefault" />
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable dark mode</label>
                </div>
            </div>
        </nav>
    )
}

// Navbar.propTypes = {
//     title: PropTypes.string.isRequied,
//     aboutText: PropTypes.string.isRequied
// }

Navbar.defaultProps = {
    title: 'set title here',
    aboutText: 'this is a about title'
};